import type { IAccountDataResponse, IAviatorSessionMap } from '@hit-game/shared/types';

/** `accountId → số dư sống`. */
export type LiveBalances = Readonly<Record<string, number | null | undefined>>;

/**
 * Số dư socket của các phiên Máy bay đang chạy, về dạng `accountId → số dư`.
 * `null` (socket chưa biết) bỏ qua — thẻ giữ số trong DB.
 */
export function balancesFromAviatorSessions(sessions: IAviatorSessionMap): LiveBalances {
  return Object.fromEntries(
    Object.entries(sessions).map(([accountId, session]) => [accountId, session.balance]),
  );
}

/**
 * Ghép số dư SOCKET vào thẻ tài khoản đang chơi.
 *
 * Bình thường sảnh tải lại danh sách từ DB mỗi 30 giây — đủ cho tài khoản không chạy.
 * Nhưng đang chơi thì mỗi ván đổi số dư, thẻ sẽ luôn chậm vài ván so với tin Telegram
 * (lấy từ socket). Nên khi có tài khoản đang chạy, sảnh hỏi số dư sống dày hơn và ghép
 * vào đây. Lãi/lỗ trong game tính lại theo cùng công thức server (`rút + số dư − nạp`)
 * để hai số trên thẻ không lệch nhau.
 *
 * Trả về MẢNG CŨ khi không có gì đổi, để React khỏi render lại vô ích mỗi nhịp hỏi.
 */
export function mergeLiveBalances(
  accounts: IAccountDataResponse[],
  live: LiveBalances,
): IAccountDataResponse[] {
  let changed = false;

  const merged = accounts.map((account) => {
    const balance = live[String(account._id)];
    if (typeof balance !== 'number' || balance === account.balance) return account;

    changed = true;
    const { totalDeposit, totalWithdraw } = account;
    return {
      ...account,
      balance,
      ...(typeof totalDeposit === 'number' && typeof totalWithdraw === 'number'
        ? { inGameProfit: totalWithdraw + balance - totalDeposit }
        : {}),
    };
  });

  return changed ? merged : accounts;
}
